<div id="version-version-div" *ngIf="showVersion">
  <div id="version-inner-div">
    <p id="version-environment">Environment: {{environment.environmentName}}</p>
    <p id="version-version">Version: {{environment.version}}</p>
  </div>
</div>
